import { Action } from '@ngrx/store';
import { MapPolyline } from '@polaris-customerweb/sharedcomponents.shared';
import {
    PlannedRide,
    PlannedRideViapoint,
    PlannedRideWaypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';
import { MapPoint } from 'src/app/models/map-point';

export const PlannedRideAction = {
    addMapPointToPlannedRide: '[planned ride] add map point to planned ride',
    addMapPolylineToPlannedRide:
        '[planned ride] add map polyline to planned ride',
    addPlannedRide: '[planned ride] add planned ride',
    cancelAddMapPointToPlannedRide:
        '[planned ride] cancel add map point to planned ride',
    forcePlannedRideRefresh: '[planned ride] refresh on next pull',
    redoEditablePlannedRide: '[planned ride] redo last editable planned ride',
    removeMapPointFromPlannedRide:
        '[planned ride] remove map point from planned ride',
    removePlannedRide: '[planned ride] remove planned ride',
    setActivePlannedRide: '[planned ride] set active planned ride',
    setAdhocWaypoint: '[planned ride] set adhoc waypoint',
    setEditablePlannedRide: '[planned ride] set editable planned ride',
    setExcludeRouteOptions: '[planned ride] set exclude route options',
    setIsRidePlanning: '[planned ride] set is ride planning',
    setIsRideTypeSelected: '[planned ride] set is ride type selected',
    setPlannedRides: '[planned ride] set planned rides',
    setTempViapoint: '[planned ride] set temp viapoint',
    toggleActivePlannedRide: '[planned ride] toggle active planned ride',
    undoEditablePlannedRide: '[planned ride] undo last editable planned ride',
    updatePlannedRide: '[planned ride] update planned ride',
};

export class AddMapPointToPlannedRide implements Action {
    type = PlannedRideAction.addMapPointToPlannedRide;
    constructor(public mapPoint: MapPoint | undefined) {}
}

export class RemoveMapPointFromPlannedRide implements Action {
    type = PlannedRideAction.removeMapPointFromPlannedRide;
    constructor(public mapPoint: MapPoint | undefined) {}
}

export class AddMapPolylineToPlannedRide implements Action {
    type = PlannedRideAction.addMapPolylineToPlannedRide;
    constructor(public mapPolyline: MapPolyline | undefined) {}
}

export class AddPlannedRide implements Action {
    type = PlannedRideAction.addPlannedRide;
    constructor(public plannedRide: PlannedRide) {}
}

export class CancelAddMapPointToPlannedRide implements Action {
    type = PlannedRideAction.cancelAddMapPointToPlannedRide;
}

export class ForcePlannedRideRefresh implements Action {
    type = PlannedRideAction.forcePlannedRideRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class RemovePlannedRide implements Action {
    type = PlannedRideAction.removePlannedRide;
    constructor(public plannedRideId: string) {}
}

export class SetActivePlannedRide implements Action {
    type = PlannedRideAction.setActivePlannedRide;
    constructor(public plannedRide: PlannedRide | undefined) {}
}

export class SetAdhocWaypoint implements Action {
    type = PlannedRideAction.setAdhocWaypoint;
    constructor(public adhocWaypoint: PlannedRideWaypoint | undefined) {}
}

export class SetEditablePlannedRide implements Action {
    type = PlannedRideAction.setEditablePlannedRide;
    constructor(
        public plannedRide: PlannedRide | undefined,
        public includeInHistory = true
    ) {}
}

export class UndoEditablePlannedRide implements Action {
    type = PlannedRideAction.undoEditablePlannedRide;
}

export class RedoEditablePlannedRide implements Action {
    type = PlannedRideAction.redoEditablePlannedRide;
}

export class SetExcludeRouteOptions implements Action {
    type = PlannedRideAction.setExcludeRouteOptions;
    constructor(public excludeRouteOptions: string) {}
}

export class SetIsRidePlanning implements Action {
    type = PlannedRideAction.setIsRidePlanning;
    constructor(public isRidePlanning: boolean) {}
}

export class SetIsRideTypeSelected implements Action {
    type = PlannedRideAction.setIsRideTypeSelected;
    constructor(public isRideTypeSelected: boolean) {}
}

export class SetPlannedRides implements Action {
    type = PlannedRideAction.setPlannedRides;
    constructor(public plannedRides: PlannedRide[]) {}
}

export class SetTempViapoint implements Action {
    type = PlannedRideAction.setTempViapoint;
    constructor(public tempViapoint: PlannedRideViapoint | undefined) {}
}

export class ToggleActivePlannedRide implements Action {
    type = PlannedRideAction.toggleActivePlannedRide;
    constructor(public plannedRide: PlannedRide) {}
}

export class UpdatePlannedRide implements Action {
    type = PlannedRideAction.updatePlannedRide;
    constructor(public plannedRide: PlannedRide) {}
}
